import React from 'react';
import type {WorkflowResponse} from 'src/api/ProactApiClient';
import {WorkflowTimelineCompact} from 'src/app/workflows/WorkflowTimelineCompact';

interface WorkflowExecutionTimelineProps {
  workflow: WorkflowResponse;
}

export const WorkflowExecutionTimeline: React.FC<WorkflowExecutionTimelineProps> = ({
  workflow,
}) => {
  return <WorkflowTimelineCompact workflow={workflow} />;
};
